import { render, staticRenderFns } from "./RecruitmentCreate.vue?vue&type=template&id=9f034b72"
import script from "./RecruitmentCreate.vue?vue&type=script&lang=js"
export * from "./RecruitmentCreate.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentCreate.vue?vue&type=style&index=0&id=9f034b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports